/* eslint-disable no-plusplus */
import moment from 'moment/moment'
import history from 'utils/history'
import { WAITING_CLARIFICATION_VALUES } from 'utils/constants/application'
import Colors from './Colors'

export const isNetworkError = (err) => {
  return err.isAxiosError && !err.response
}
export const maskString = (str, pattern) => {
  if (!str) return null
  const patterns = {
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    cnae: '##.##-#-##',
  }
  let i = 0
  
  return patterns[pattern].replace(/#/g, () => {
    return str[i++]
  })
}

export const randomKey = (componentName = '') => {
  return `${componentName}_${Math.random().toString(36).substring(2, 10)}`
}

export const buildScore = (score) => {

  if (score <= 1.9) return { color: Colors.green }

  if (score >= 2 && score <= 2.99) return { color: Colors.yellow }

  if (score >= 3 && score <= 3.99) return { color: Colors.orange }

  return { color: Colors.red }
}

export const buildRiskColor = (riskLevel) => {
  const colors = {
    'UNDEFINED': Colors.textColor,
    'LOW': Colors.green,
    'MEDIUM': Colors.yellow,
    'HIGH': Colors.orange,
    'HIGH_PEP': Colors.orange,
    'HIGH_ATTENTION_LIST': Colors.orange,
    'VERY_HIGH': Colors.red,
    'VERY_HIGH_DENY_LIST': Colors.red,
  }

  return colors[riskLevel]
}

export const buildRiskMessage = (riskLevel) => {
  const messages = {
    undefined: 'N/A',
    'UNDEFINED': 'Indefinido',
    'LOW': 'Baixo',
    'MEDIUM': 'Médio',
    'HIGH': 'Alto',
    'HIGH_PEP': 'Alto (devido a ser PEP)',
    'HIGH_ATTENTION_LIST': 'Alto (devido a constar na "Attention List")',
    'VERY_HIGH': 'Muito Alto',
    'VERY_HIGH_DENY_LIST': 'Muito Alto ("Deny List")',
  }

  return messages[riskLevel]
}

export const convertToBrazilianCurrency = (value) => {
  return value.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
}

export const dateFormats = {
  br_date_time: "DD/MM/yyyy HH:mm:ss",
  br_date: "DD/MM/yyyy",
}

export const formatDateTime = (value, format = dateFormats.br_date_time) => {
  return moment(value).format(format)
}

export const formatDuration = (value) => {
  if (!value || value < 0 || !Number.isFinite(value)) {
    return null
  }

  if (value < 1000) {
    return `${Math.round(value)} ms`
  }

  return `${(value / 1000).toFixed(2).replace('.', ',')} s`
}


export const gotoUrl = (url) => {
  history.push({ pathname: url })
  history.go(0)
}

export const setApplicationQueryParam = (routerHistory, applicationUuid) => {
  const params = new URLSearchParams(routerHistory.location.search)

  if (applicationUuid) {
    params.set('application_uuid', applicationUuid)
  } else {
    params.delete('application_uuid')
  }

  const search = params.toString()
  routerHistory.replace({
    pathname: routerHistory.location.pathname,
    search: search ? `?${search}` : '',
  })
}

export const setSearchFiltersQueryParams = (routerHistory, filters) => {
  const params = new URLSearchParams(routerHistory.location.search)

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      params.set(key, value)
    } else {
      params.delete(key)
    }
  })

  const search = params.toString()
  routerHistory.replace({
    pathname: routerHistory.location.pathname,
    search: search ? `?${search}` : '',
  })
}

const getSearchFieldForTerm = (userInput) => {
  const cpfRegex = new RegExp('^[0-9.-]*$')

  if (cpfRegex.test(userInput.toLowerCase())) {
    return 'candidate_cpf'
  }
  return 'candidate_name'
}

// Single source of truth for the filters, shared by SearchBar (form state) and Home (initial API call).
export const getFilterValuesFromQueryParams = (search) => {
  const params = new URLSearchParams(search)

  return {
    initDate: params.get('start_date') || '',
    endDate: params.get('end_date') || '',
    status: params.get('status') || 'ALL',
    result: params.get('result') || 'ALL',
    showWaitingClarification: params.get('waiting_clarification') || 'ALL',
    showEmptyApplications: params.get('show_apps_without_bgc') === 'true',
    searchTerm: params.get('query') || '',
  }
}

export const buildApplicationSearchParams = (filterValues) => {
  const { initDate, endDate, status, result, showEmptyApplications, showWaitingClarification, searchTerm } =
    filterValues
  const searchParam = {
    start_date: initDate !== '' ? initDate : undefined,
    final_date: endDate !== '' ? endDate : undefined,
    status: status !== 'ALL' ? status : undefined,
    result: result !== 'ALL' ? result : undefined,
    waiting_clarification: WAITING_CLARIFICATION_VALUES[showWaitingClarification],
    hide_empty_applications: !showEmptyApplications,
  }

  if (searchTerm !== '') {
    searchParam[getSearchFieldForTerm(searchTerm)] = searchTerm
  }

  return searchParam
}

